/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardLoginDto } from '../../models/dashboard-login-dto';

export interface DashboardAuthControllerLogin$Params {
      body: DashboardLoginDto
}

export function dashboardAuthControllerLogin(http: HttpClient, rootUrl: string, params: DashboardAuthControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'apiToken'?: string;
'user'?: {
'id'?: string;
'email'?: string;
'fullName'?: string;
'company'?: string;
};
}>> {
  const rb = new RequestBuilder(rootUrl, dashboardAuthControllerLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'apiToken'?: string;
      'user'?: {
      'id'?: string;
      'email'?: string;
      'fullName'?: string;
      'company'?: string;
      };
      }>;
    })
  );
}

dashboardAuthControllerLogin.PATH = '/dashboard/auth/login';
